import AccountInfoModel from './AccountInfo';
import BannersModel from './Banners';
import { LeasesForPropertyModel } from './LeasesForProperty';
import IdentityVerificationModel from './IdentityVerification';
import PropertyInfoModel from './PropertyInfo';
import UserConfigModel from './UserConfig';
import UserEventModel from './UserEvent';
import DismissibleActionStatus from '@common/models/DismissibleActionStatus';
import TransactionsModel from './Transactions';
import type { ILandlordStatusNumericInputModel } from './Types';
import PaymentScheduleInfo from './PaymentScheduleInfo';

const LandlordStatusModel = (data: ILandlordStatusNumericInputModel, today = new Date()) => {
  const {
    email = '',
    status = '',
    accountInfo = {
      accountName: '',
      accountType: '',
      accountLast4: '',
    },
    identityVerification = {
      additionalVerificationRequired: false,
      legalEntityVerificationStatus: '',
    },
    propertyInfoV2 = {},
    userEvents = [
      {
        eventType: '',
        createdDate: '',
      },
    ],
    userConfig = {},
    dismissibleActions = {},
    transactions = [],
    leasesForProperty = [],
    selectedLease = {},
    paymentScheduleInfo = {
      firstAvailableEndDate: 0,
    },
    isHighRiskOtpApproved = false,
    banners = [],
  } = data;

  const { currentTerm, nextTerm } = PropertyInfoModel(propertyInfoV2, today);
  const termEnded = currentTerm.termEnded;
  const propertyId = data?.propertyInfoV2?.current?.propertyId;
  const address = data?.propertyInfoV2?.current?.address || '';

  return {
    ...data,
    propertyId,
    address,
    email: email && String(email),
    landlordStatus: status && String(status),
    accountInfo: AccountInfoModel(accountInfo),
    identityVerification: IdentityVerificationModel(identityVerification),
    userEvent: termEnded ? {} : UserEventModel(userEvents),
    userConfig: UserConfigModel(userConfig),
    dismissibleActions: DismissibleActionStatus(dismissibleActions),
    currentTerm,
    nextTerm,
    allTransactions: TransactionsModel(transactions, currentTerm, nextTerm),
    leasesForProperty: (leasesForProperty.length > 0 && LeasesForPropertyModel(leasesForProperty)) || [],
    selectedLease: selectedLease || {},
    paymentScheduleInfo: PaymentScheduleInfo(paymentScheduleInfo),
    isHighRiskOtpApproved,
    banners: BannersModel(banners),
  };
};

export default LandlordStatusModel;
